import { Directive, DoCheck, ElementRef, inject, input, InputSignal, Renderer2 } from '@angular/core';
import { AttributesModel, InputItemBaseModel } from '@libs/form/models';

@Directive({
  selector: 'input[uiFormInputAttributes],textarea[uiFormInputAttributes],select[uiFormInputAttributes]',
})
export class InputAttributesDirective implements DoCheck {
  private readonly elementRef: ElementRef = inject(ElementRef);
  private readonly renderer: Renderer2 = inject(Renderer2);

  public data: InputSignal<InputItemBaseModel> = input.required();

  public ngDoCheck(): void {
    const attributes: AttributesModel | undefined = this.data().attributes;

    if (attributes) {
      this.updateAttributes(attributes);
    }
  }

  private updateAttributes(attributes: AttributesModel): void {
    Object.keys(attributes).forEach((key: string) => {
      this.renderer.setProperty(this.elementRef.nativeElement, key, attributes[key as keyof AttributesModel]);
    });
  }
}
